import { Model } from './Model';

export class ProductKey {
  [k: number]: Model;

  constructor(products: Array<Model>) {
    products.forEach(p => this[p.id] = p);
  }
}
